import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useGclid } from '../hooks/useGclid';
import { buildShopUrl, trackCTAClick } from '../utils/tracking';
interface InlineCTAProps {
  label: string;
  position: string;
}
export function InlineCTA({
  label,
  position
}: InlineCTAProps) {
  const gclid = useGclid();
  const href = buildShopUrl('https://hunderunde.shop/products/futtertopping-magen-darm', gclid);
  return <section className="w-full px-4 py-12" data-id="element-126">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-2xl mx-auto text-center" data-id="element-127">
        <a href={href} onClick={() => trackCTAClick(label, position)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-forest hover:bg-forest-light text-white font-serif font-bold text-lg md:text-xl py-4 px-8 md:px-12 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 w-full md:w-auto" data-id="element-128">
          {label}
          <ArrowRight className="w-6 h-6" data-id="element-129" />
        </a>
      </motion.div>
    </section>;
}